"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenState = exports.ScreenType = void 0;
var ScreenType;
(function (ScreenType) {
    ScreenType[ScreenType["Menu"] = 0] = "Menu";
    ScreenType[ScreenType["EinsteinDiscovery"] = 1] = "EinsteinDiscovery";
    ScreenType[ScreenType["RServe"] = 2] = "RServe";
    ScreenType[ScreenType["TabPy"] = 3] = "TabPy";
    ScreenType[ScreenType["AnalyticsExtensionsAPI"] = 4] = "AnalyticsExtensionsAPI";
})(ScreenType = exports.ScreenType || (exports.ScreenType = {}));
var ScreenState;
(function (ScreenState) {
    ScreenState[ScreenState["isEnabled"] = 0] = "isEnabled";
    ScreenState[ScreenState["isDisabled"] = 1] = "isDisabled";
    ScreenState[ScreenState["isExecuting"] = 2] = "isExecuting";
    ScreenState[ScreenState["didError"] = 3] = "didError";
})(ScreenState = exports.ScreenState || (exports.ScreenState = {}));
//# sourceMappingURL=ScreenTypes.js.map